import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../assets/css/JobDetails.css";
import image from "../assets/Hero/career-logo.png";

export const JobDetails = () => {
  const { jobId } = useParams(); // Get the job ID from the URL
  const [job, setJob] = useState(null); // State to hold job details
  const [loading, setLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state

  useEffect(() => {
    // Fetch the data dynamically
    import("../data/data.json")
      .then((data) => {
        const job = data.Careers.find((job) => job.id === jobId);
        if (job) {
          setJob(job);
        } else {
          setError("Job not found!");
        }
      })
      .catch(() => setError("Failed to load job data."))
      .finally(() => setLoading(false));
  }, [jobId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="job-details-not-found">{error}</div>;
  }

  return (
    <div className="job-details-page">
      {/* Hero Section */}
      <div className="job-details-hero">
        <img
          src={image}
          alt={`${job.title} Hero`}
          className="job-details-hero-image"
        />
        <div className="job-details-hero-text">
          <h1 className="job-details-title">{job.title}</h1>
          <p className="job-details-subtitle">{job.description}</p>
        </div>
      </div>

      {/* Details Section */}
      <div className="job-details-container">
        <section className="job-details-section">
          <h2 className="job-details-heading">Must Haves</h2>
          <ul className="job-details-list">
            {job.mustHaves.map((item, i) => (
              <li key={i} className="job-details-list-item">
                {item}
              </li>
            ))}
          </ul>
        </section>
        <section className="job-details-section">
          <h2 className="job-details-heading">Preferred Skills</h2>
          <ul className="job-details-list">
            {job.preferredSkills.map((item, i) => (
              <li key={i} className="job-details-list-item">
                {item}
              </li>
            ))}
          </ul>
        </section>
        <section className="job-details-section">
          <h2 className="job-details-heading">Key Responsibilities</h2>
          <ul className="job-details-list">
            {job.keyResponsibilities.map((item, i) => (
              <li key={i} className="job-details-list-item">
                {item}
              </li>
            ))}
          </ul>
        </section>
        <section className="job-details-section">
          <h2 className="job-details-heading">How to Apply</h2>
          <p className="job-details-paragraph">
            If you meet the above qualifications and are excited to help businesses harness the full potential of Microsoft Dynamics 365 Business Central, we’d love to hear from you. Please send your application to 
            <a
              href="mailto:careers@defttech.co.ke "
              className="job-details-email-link"
            >
               <span> <strong>careers@defttech.co.ke </strong> </span>
            </a>{" "}
            with the subject line: <b>“Dynamics 365 Functional Consultant – Business Central”.</b>
          </p>
          <p className="job-details-paragraph">
            <strong className="job-details-deadline">
              Application deadline is {job.deadline}.
            </strong>
          </p>
          <p className="job-details-paragraph">
            We are an equal opportunity employer and value diversity at our
            company. We do not discriminate on the basis of race, religion,
            color, national origin, gender, sexual orientation, age, marital
            status, veteran status, or disability status.
          </p>
          <p className="job-details-paragraph job-details-note">
            <strong>NOTE:</strong> Only shortlisted applicants will be
            contacted.
          </p>
        </section>
        <button
          onClick={() => window.history.back()}
          className="job-details-back-btn"
        >
          Go Back
        </button>
      </div>
    </div>
  );
};
